let _ = require('../_.js');
var $ = jQuery;

//
// ui_update.js 
//
// Callbacks for selectors that execute when the element is first discovered on the page.
// This code hooks into jquery methods to catch when new elements may be added on the page
// to intellegently check if they are an element we are looking for.  The developer can
// pretty much ignore manually selecting and initializing new dom components as long as 
// all operations of adding and removing stuff from the dom dynamically are done through jquery.
//
// This also contains a callback for window resizing.  Some methods may call the resize callbacks
// manually even without resize (for example, major ui changes).
//

// Force redraw everything
_.ui_update = async function () {
  // console.trace();
  needs_ui_resize = true;
  queue_ui_update_once_element($("body"));
  await _parse_and_execute_callbacks();
}

// Register the selector and callback
_.on_ui_update_once = function (selector, callback) {
  if (typeof (callback) != 'function') {
    console.error("Not a function", callback);
  }

  let hash = _.uniqueId('ui_update_once_');

  uiUpdateOnceCallbacks.push({
    selector: selector,
    callback: callback,
    hash: hash
  });

  queue_ui_update_once_element($("body"));
}

// Function to register the selector and callback, it gets called every time on a matched selector, not just the first time.
// 'selector' can be null, this will just call the callback every time the ui_update loop is called, for no specific element
_.on_ui_update_always = function (selector, callback, force_update = false) {
  // console.warn("On update");
  if (typeof (callback) != 'function') {
    console.error("Not a function", callback);
  }

  uiUpdateAlwaysCallbacks.push({
    selector: selector,
    callback: callback
  });
}

// Function to register a callback that executes when the window resizes
_.on_ui_resize = function (callback) {
  // console.warn("On Resize");
  if (typeof (callback) != 'function') {
    console.error("Not a function", callback);
    return;
  }
  uiResizeCallbacks.push(callback);

  // Register resize event if not registered yet
  if (uiResizeCallbacks.length === 1) {
    $(window).resize(_ui_resize);
  }

  _ui_resize();
}




// ------------- Private ---------------


// Define the list of callbacks
let uiUpdateOnceCallbacks = [];
let uiUpdateOnceElementQueue = [];
let uiUpdateOnceIsQueued = false;
let uiResizeCallbacks = [];
let uiUpdateAlwaysCallbacks = [];



async function queue_ui_update_once_element($element) {
  async function run() {
    // Don't do ui updates while animating
    // await wait_for_animations_to_complete();

    // Ensure the element exists and is not already in the queue
    if (typeof ($element[0]) !== 'undefined' && !uiUpdateOnceElementQueue.includes($element[0])) {
      uiUpdateOnceElementQueue.push($element[0]); // Store the DOM element
      queue_ui_update_once();
    }
  }

  // Ensure the document is fully loaded before running the logic
  if (document.readyState === 'complete') {
    run();
  } else {
    $(document).ready(run);
  }
}

let _ui_update_queued = false;

function queue_ui_update_once() {
  if (_ui_update_queued) return;
  _ui_update_queued = true;

  if (document.readyState === 'complete') {
    $.eventQueue.push(_parse_and_execute_callbacks);
  } else {
    $(document).ready(function () {
      $.eventQueue.push(_parse_and_execute_callbacks);
    });
  }
}

// UI refresh callback - processes queued element updates
async function _parse_and_execute_callbacks() {
    _ui_update_queued = false;
    // await $(':animated').promise();

    // console.trace();
    let queue = uiUpdateOnceElementQueue;
    uiUpdateOnceElementQueue = [];
    uiUpdateOnceIsQueued = false;

    if (queue.length > 0) {
      // console.warn("Redraw");
    }

    queue = [...new Set(queue)]; // Remove duplicates

    // Remove children which are decendents of other elements already in the queue
    queue = queue.filter(function (element) {
      return !$(element).parents().toArray().some(function (parent) {
        return queue.includes(parent);
      });
    });

    // Execute each selector and find matching elements
    for (let i1 = 0; i1 < uiUpdateOnceCallbacks.length; i1++) {
      let item = uiUpdateOnceCallbacks[i1];
      let callback_selector = item.selector;
      let callback = item.callback;
      let hash = item.hash;

      for (let i2 = 0; i2 < queue.length; i2++) {
        let element = queue[i2];

        if (!element) {
          // Sometimes 'undefined' elements end up here.  Not sure if this is a concern.
          continue;
        }

        let $element;

        // Check if element is a raw DOM element
        if (element instanceof HTMLElement) {
          $element = $(element); // wrap in jQuery object
        } else if (element instanceof jQuery) { // check if it's a jQuery object
          $element = element;
        } else {
          console.warn("Unexpected type for element:", element);
          return; // Skip to next iteration
        }

        let callback_targets = [];

        $element.find(callback_selector).addBack(callback_selector).each(function () {
          callback_targets.push(this);
        });

        for (let i2 = 0; i2 < callback_targets.length; i2++) {
          let $child = $(callback_targets[i2]);
          let child_dom = callback_targets[i2];
          // we use 'hash' to check if this callback was already called on the element
          if (!$child.data(hash)) {
            $child.data(hash, true);
            await callback.bind(child_dom).call(child_dom);
          }
        }
      }
    }

    // These ones always get called on refresh
    for (let i1 = 0; i1 < uiUpdateAlwaysCallbacks.length; i1++) {

      let item = uiUpdateAlwaysCallbacks[i1];

      let selector = item.selector;
      let callback = item.callback;


      if (selector !== null) {
        let selector_targets = [];
        $(selector).each(function () {
          selector_targets.push(this);
        });

        for (let i2 = 0; i2 < selector_targets.length; i2++) {
          await callback.call($(selector_targets[i2]));
        }
      } else {
        await callback();
      }
    }


    if (needs_ui_resize) {
      needs_ui_resize = false;
      await _ui_resize();
    }

    // We only call one resize per animation.  Lets wait for animations to complete before calling again.
    // let did_animations = await wait_for_animations_to_complete();

    // if (did_animations) {
    //   queue_ui_update_once();
    // }
}


let ui_update_allowed = true;
// Calls inner function with a flag to prevent queueing more ui updates
_.ui_prevent_update_loop = async function (callback) {
  ui_update_allowed = false;
  await callback();
  ui_update_allowed = true;
};

// Fancy function to detect events which necessitate calls to queue_ui_update_once_element()
let jquery_methods_to_hook = ['append', 'prepend', 'after', 'before', 'html', 'text', 'show', 'fadeIn', 'slideIn', 'addClass'];

let is_handling_resize = false;
let needs_ui_resize = false;

$.each(jquery_methods_to_hook, function (index, method) {
  let oldMethod = $.fn[method];

  // Adding new methods which just calls the original functions
  let originalMethod = 'o' + method.charAt(0).toUpperCase() + method.slice(1);

  $.fn[originalMethod] = function () {
    return oldMethod.apply(this, arguments);
  };

  $.fn[method] = function () {
    if (is_handling_resize) {
      return oldMethod.apply(this, arguments);
    }

    let isEmptySet = this.length === 0;
    let r;
    let didChangeContent = false;

    if (!isEmptySet) {
      let shouldUpdate = true;

      // If the method is 'addClass', check if the element already has the class.
      if (method === 'addClass' && this.hasClass(arguments[0])) {
        shouldUpdate = false;
      }

      // If the method is one of 'show', 'fadeIn', 'slideIn', check if the element is already visible.
      if (['show', 'fadeIn', 'slideIn'].includes(method) && this.is(':visible')) {
        shouldUpdate = false;
      }

      // On text or html, if content of textbox height changes, redraw
      // todo: This could be further improved by including 'empty' here, then if any of these 3 get called,
      // put the item on an array for 'first check' and use setTimeout to evaluate its change after
      // any of these 3 are done, async, to check for redraw.
      let height_check = null;
      if (['html', 'text'].includes(method) && this.is(':visible')) {
        height_check = this.height();
      }

      // Call the original jQuery method.
      r = oldMethod.apply(this, arguments);

      if (['html', 'text'].includes(method) && this.is(':visible')) {
        if (height_check != this.height()) {
          if (ui_update_allowed) {
            _queue_ui_resize();
          }
        }
      }

      if (shouldUpdate) {
        // For these methods, we clear the ui_update_parsed data and execute callbacks.
        this.each(function () {
          let $element = $(this);
          if (['append', 'prepend', 'addClass'].includes(method) || !$element.data('ui_update_parsed')) {
            $element.data('ui_update_parsed', true);
            if (ui_update_allowed) {
              queue_ui_update_once_element($element);
            }
          } else if (['after', 'before'].includes(method) && $element.parent().length) {
            if (ui_update_allowed) {
              queue_ui_update_once_element($element.parent());
            }
          } else if (['after', 'before', 'append', 'prepend', 'show', 'fadeIn'].includes(method)) {
            if (ui_update_allowed) {
              _queue_ui_resize();
            }
          }
        });
      }
    } else {
      r = oldMethod.apply(this, arguments);
    }

    return r;
  };
});




// Function to execute the registered callbacks on resize
let _queue_ui_resize = function () {
  needs_ui_resize = true;
  setTimeout(_._ui_resize_immediate, 0);
  // setTimeout(_._ui_resize_immediate, 100);
}

let _ui_resize = _.debounce(0, async function () {
  await _.___ui_resize();
});

// Hack to make resize happen on .show() on any item
// All of this nonsense is to figure out a way to get the auto 100% height grow function to not run as often
// Might want to scruitinize this closer some day.
_._ui_resize_immediate = _.debounce(0, async function () {
  await _.___ui_resize();
});

_.___ui_resize = _.debounce(0, async function () {
  // await _.mutex_read('_core_resize', async function () {
  (async function () {

    // Wait for jquery animations to complete
    // This is problematic... it doesnt always work...
    await $(':animated').promise();

    let encountered_error = false;
    is_handling_resize = true;
    // Call the callbacks twice, this is a hack to deal with some chain reaction events
    // that make the code much easier to write elsewhere.
    for (let i = 0; i < 2; i++) {
      uiResizeCallbacks.forEach(function (callback) {
        let result = callback.call(window);
        if (result instanceof Promise) {
          console.error('Error: Callback returned a Promise. Resize callbacks must be synchronous.');
          encountered_error = true;
        }
      });
    }
    if (!encountered_error) {
      is_handling_resize = false;
    }

    // We only call one resize per animation.Lets wait for animations to complete before calling again.
    // await wait_for_animations_to_complete();
    // });

  })();
});


// Watch for images finish loading
document.addEventListener('DOMContentLoaded', function () {
  const processImage = (img) => {
    // Function to be called on each image load
    _ui_resize();
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.tagName === 'IMG') {
            if (node.complete) {
              processImage(node);
            } else {
              node.addEventListener('load', () => processImage(node));
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Apply the function to all images already in the DOM
  document.querySelectorAll('img').forEach((img) => {
    if (img.complete) {
      processImage(img);
    } else {
      img.addEventListener('load', () => processImage(img));
    }
  });
});

